import React, { useContext, ReactNode } from 'react';

import { PermissionsContext } from '../context/permissionsContext';

interface RenderIfHasPermissionProps {
  permission: string;
  children: ReactNode;
  orCondition?: boolean;
  andCondition?: boolean;
}

const RenderIfHasPermission: React.FC<RenderIfHasPermissionProps> = ({
  permission,
  children,
  orCondition = false,
  andCondition = true,
}) => {
  const { permissions, loading } = useContext(PermissionsContext);
  if (loading) return null;
  if ((permissions.includes(permission) || !!orCondition) && !!andCondition) {
    return <>{children}</>;
  }
  return null;
};

export default RenderIfHasPermission;
